import React from 'react';
import { BrowserRouter as Router,Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import '@fortawesome/fontawesome-free/css/all.min.css';
import Header from './pages/Header';
import Home from './component/Home';
import Footer from './component/Footer';
import Testimonialabout from './pages/Testimonialabout';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FaqsSection from './pages/FaqsSection';
import Ourfleet from './pages/Ourfleet';
import Packages from './pages/Packages';
import OurNetwork from './pages/Network';
import ApartmentSection from './pages/Apartment';
import ContactSection from './pages/ContactSection';
import Aboutsectionn from './pages/AboutSection';
import Booking from './pages/Booking';
import Copporatebusserviceinpune from './pages/Corporate Bus Services Pune';
import Coproratecabandbusserviceinahemadnagar from './pages/Corporate Cab and Bus Service in Ahmednagar';
import ScrollToTop from './component/ScrollToTop';
import Coproratecabandbusserviceinamravati from './pages/Corporate Cab and Bus Service in Amravati';
import Coproratecabandbusserviceinkohlapur from './pages/Corporate Cab and Bus Service in Kolhapur';
import Coproratecabandbusserviceisangli from './pages/Corporate Cab and Bus Service in Sangli';
import Coproratecabandbusserviceisatara from './pages/Corporate Cab and Bus Service in Satara';
import Corporateoutstation from './pages/Corporate Cab and Bus Services for Outstation';
import Corporatecabandbusaundh from './pages/Corporate Cab and Bus Services in Aundh';
import Corporatecabandbusserviceinauranga from './pages/Corporate Cab and Bus Services in Aurangabad';
import Corporatecabandbusserviceinbhosari from './pages/Corporate Cab and Bus Services in Bhosari MIDC';
import Corporatecabandbusserviceinhadapsar from './pages/Corporate Cab and Bus Services in Hadapsar';
import Corporatecabandbusserviceinhinjewadi from './pages/Corporate Cab and Bus Services in Hinjewadi';
import Corporatecabandbusserviceinhinmumbai from './pages/Cab Services for Corporate Travellers in Mumbai';
import Corporatecabandbusserviceinhinnashik from './pages/Corporate Cab and Bus Services in Nashik';
import Corporatecabandbusserviceinpune from './pages/Corporate Cab and Bus Services in Pune';
import Corporatecabandbusserviceinsanaswadi from './pages/Corporate Cab and Bus Services in Sanaswadi';
import Corporatecabandbusserviceinshirwal from './pages/Corporate Cab and Bus Services in Shirwal MIDC';
import Corporatecabinsolapur from './pages/Corporate Cab and Bus Services in Solapur';
import Corporatecabintalawade from './pages/Corporate Cab and Bus Services in Talwade MIDC';
import Corporatecabandbusservicepuneairport from './pages/Corporate Cab and Bus Services Pune Airport';
import Corporatecabandbusservicepuneranjangaon from './pages/Corporate Cabs and Bus in Ranjangaon MIDC';
import Corporatecabandbusservicepunechakan from './pages/Corporate Cabs and Bus Services in Chakan';
import Corporatecabandbusservicepunenagpur from './pages/Corporate Cabs and Bus Services in Nagpur';
import Onewaycabservicemumbaitopunedrop from './pages/One Way Cab Services Mumbai to Pune Drop';
import ContactButtons from './component/ContactButtons';
import Busserviceforcorporatepune from './pages/Bus Service for Corporate Pune';
import Busonrentinpuneforcorporate from './pages/Bus On Rent in Pune for Corporate Events';
import Urbaniaonrentinpuneforcorporate from './pages/Urbania On Rent in Pune for Corporate';
import Corporatetransportserviceinpune from './pages/Corporate Transport Services in Pune';
import Luxurybushireforcorporateinpune from './pages/Luxury Bus Hire for Corporate in Pune';
import Acbusrentalforcorporatepune from './pages/AC Bus Rental for Corporate Pune';
import Busrentalforcorporateoutingpune from './pages/Bus Rental for Corporate Outings Pune';
import Volvobusonrentforcorporate from './pages/Volvo Bus on Rent for Corporate in Pune';
import Corporatetourbusserviceinpune from './pages/Corporate Tour Bus Services in Pune';
import Tempotravelleronrentforcorporate from './pages/Tempo Traveller on Rent for Corporate Pune';
import Innovacrystahireforcorporateevents from './pages/Innova Crysta Hire for Corporate Events';
import Urbaniahireforcorporate from './pages/Urbania Hire for Corporate Event in Pune';
import Busrentalforcorporateevents from './pages/Bus Rental For Corporate Events in Pune';
import Corporatecabserviceinpune from './pages/Corporate Cab Service in Pune Airport';
import Minibushireforcorporate from './pages/Mini Bus Hire for Corporate in Pune';
import Luxurycabserviceinpuneforcorporate from './pages/Luxury Cab Service in Pune for Corporate';
import Monthlycarrentalcabserviceinpune from './pages/Monthly Car Rental Cab Service in Pune';
import Monthlycabserviceinmumbai from './pages/Monthly Cab Service in Mumbai';
import Monthlycabserviceinnavymumbai from './pages/Monthly Cab Service in Navi Mumbai';
import Monthlycabserviceinthane from './pages/Monthly Cab Service in Thane';
import Monthlycabserviceinpimprichichwad from './pages/Monthly Cab Service in Pimpri Chinchwad';
import Corporatecabserviceinpanvel from './pages/Corporate Cab Service in Panvel';
import Cabsforcorporatepicnic from './pages/Cabs for Corporate Picnic in Pune';
import Bushireforcorporatepicnicinpune from './pages/Bus Hire for Corporate Picnic in Pune';
import Cabserviceinwagaleindstrial from './pages/Cab Service in Wagahle Industrial Estate';
import Cabserviceintaloja from './pages/Cab Service in Taloja MIDC Mumbai';
import Corporatecabserviceinthane from './pages/Corporate Cab Services in Thane Industrial Area MIDC';
import Cabserviceinhinjewadi from './pages/Cab Service in Hinjewadi MIDC';
import Cabserviceinchichwad from './pages/Cab Service in Chinchwad MIDC Pune';
import Cabservicemahapemidc from './pages/Cab Service Mahape MIDC';
import Cabserviceinmarol from './pages/Cab Service in Marol MIDC Andheri';
import Cabserviceinpimpri from './pages/Cab Service in Pimpri MIDC';
import Cabserviceinkurkumbh from './pages/Cab Service in Kurkumbh MIDC';
import Cabserviceinsupa from './pages/Cab Service in Supa MIDC';
import Cabserviceintalawade from './pages/Cab Service in Talwade MIDC Pune';
import Cabserviceinjejuri from './pages/Cab Services in Jejuri MIDC Pune';
import Cabserviceinpabal from './pages/Cab Service in Pabal MIDC Pune';
import Cabserviceinchakan from './pages/Cab Service in Chakan MIDC';
import Cabserviceintalegaon from './pages/Cab Service in Talegaon Dabhade MIDC';
import Cabserviceinandheri from './pages/Cab Service in Andheri MIDC';
import Cabserviceinaurangabad from './pages/Cab Service in Aurangabad MIDC (Sambhaji Nagar MIDC)';
import Cabserviceinnagpur from './pages/Cab Service in Nagpur MIDC';
import Cabserviceinnanded from './pages/Cab Service in Nanded MIDC';
import Cabserviceinratnagiri from './pages/Cab Service in Ratnagiri MIDC';
import CAbserviceinsindhudurg from './pages/Cab Service in Sindhudurg MIDC';
import Cabserviceinraigad from './pages/Cab Service in Raigad MIDC';
import Csbserviceinkharadi from './pages/Cab Service in Kharadi MIDC';
import Cabserviceinwagleestatethane from './pages/Cab Service in Wagle Estate Thane';
import Cabserviceinkolhapur from './pages/Cab Service in Kolhapur MIDC';
import Cabserviceinsangli from './pages/Cab Service in Sangli MIDC';
import Cabserviceinsolapur from './pages/Cab Service in Solapur MIDC';
import Cabserviceinsatara from './pages/Cab Service in Satara MIDC';
import Cabserviceinlatur from './pages/Cab Service in Latur MIDC';
import Cabserviceinsharashiv from './pages/Cab Service in Dharashiv MIDC';
import Corporatecabserviceinjalgaon from './pages/Corporate Cab Services in Jalgaon MIDC.';
import Corporatecabserviceinjalna from './pages/Corporate Cab Service in Jalna MIDC Maharashtra';
import Taxiserviceinbeed from './pages/Taxi Service in Beed MIDC Maharashtra';
import Cabserviceinparbani from './pages/Cab Service in Parbhani MIDC';
import Cabserviceinhingoli from './pages/Cab Service in Hingoli MIDC';
import Cabserviceindhule from './pages/Cab Service in Dhule MIDC';
import Carserviceinwardha from './pages/Car Rental Service in Wardha MIDC';
import Cabserviceinchandrapur from './pages/Cab Service in Chandrapur MIDC';
import Cabserviceinamravati from './pages/Cab Service in Amravati MIDC Maharashtra';
import Cabserviceinakola from './pages/Cab Service in Akola MIDC';
import Cabserviceinyavatmal from './pages/Cab Service in Yavatmal MIDC';
import Cabserviceinbuldhana from './pages/Cab Service in Buldhana MIDC';
import Corporatecabserviceinlgatpuri from './pages/Corporate Cab Service in Igatpuri';
import Corporatecabserviceinnashik from './pages/Corporate Cab Services in Nashik';
import Monthlycarrentalcabserviceinnashik from './pages/Monthly Car Rental Cab Service in Nashik';
import Corporatecabandbusserviceinhadapsarindustrial from './pages/Corporate Cab and Bus Services in Hadapsar Industrial Area';
import Corporatecabandbusservieindhayari from './pages/Corporate Cab and Bus Services in Dhayri Industrial Area';
import Corporatecabandbusserviceinshiajinagar from './pages/Corporate Cab and Bus Services in Shivaji Nagar';
import Coporatecabandbusserviceinmagarpatta from './pages/Corporate Cab and Bus Services in Magarpatta';
import Corporatecabandbusserviceinpirangut from './pages/Corporate Cab and Bus Services in Pirangut';
import Corporatecabandbusserviceinnighole from './pages/Corporate Cab and Bus Services in Nighoje MIDC';
import Corporatecabandbusserviceinkharbwadi from './pages/Corporate Cab and Bus Services in Kharbwadi';
import Corporatecabandbusserviceinkhed from './pages/Corporate Cab and Bus Services in Khed MIDC';
import Corporatecabandbusserviceinkargaon from './pages/Corporate Cab and Bus Services in Kargaon MIDC';
import Corporatecabandbusserviceinnashikphata from './pages/Corporate Cab and Bus Services in Nashik Phata';
import Corporatecabandbusserviceinphugewadi from './pages/Corporate Cab and Bus Services in Phugewadi';
import Corporatecabandbusserviceinphulegaon from './pages/Corporate Cab and Bus Services in Phulgaon MIDC';
import Corporatecabandbusserviceinmarkal from './pages/Corporate Cab and Bus Services in Markal MIDC';
import OurServices from './pages/OurServices';
import Swift from './pages/Swift Desire';
import TempoTraveller from './pages/TempoTraveller';
import MiniBus from './pages/MiniBus';
import InnovaCrysta from './pages/InnovaCrysta';
import SedanCars from './pages/SedanCars';
import BmwLuxuryCars from './pages/BmwLuxuryCars';
import AudiLuxuryCars from './pages/AudiLuxuryCars';
import FiftySeaterBus from './pages/FiftySeaterBus';
import CorporateBus35Seater from './pages/CorporateBus35Seater';
import VolvoBusRental from './pages/VolvoBusRental';
import EnquiryForm from './pages/EnquiryForm';
import Employeetransportserviceinpune from './pages/Employee Transport Services in Pune';
import Cabandbusserviceinbaner from './pages/Cab and Bus Services in Baner';
import Cabandbusserviceinbalewadi from './pages/Cab and Bus Services in Balewadi';
import Corporatecarrentalpune from './pages/Corporate Car Rental Pune';
import Corporatestafftransportpune from './pages/Corporate Staff Transport Pune';
import Acbushireforemployees from './pages/AC Bus Hire for Employees Pune';
import Carrentalserviceinpune from './pages/Car Rental Service in Pune for Corporates';
import Bestemployyestransportationcompnies from './pages/Best Employee Transportation Companies in Pune';
import Affordableemployeestranportaion from './pages/Affordable Employee Transportation Pune';
import Endtoendcorporate from './pages/End-to-End Corporate Mobility Solutions Pune';
import Customizedmobiltyplansforemploees from './pages/Customized Mobility Plans for Employees Pune';
import Corporatecarrentalinpune from './pages/Corporate Car Rental in Pune';
import Corporatecarrentalsserviceinpune from './pages/Corporate Car Rentals Services in Pune';
import Corporatecabserviceforpuneoutstation from './pages/Corporate cab services for Pune Outstation';
import Corporatecabserviceinvimannagar from './pages/Corporate Cab Service in Viman Nagar';
import Monthlypickanddropservice from './pages/Monthly Pick and Drop Service Pune';
import Cabserviceforitcompanyinpune from './pages/Cab Service for IT Company in Pune';
import Dailyofficepickupanddropservice from './pages/Daily Office Pickup and Drop Service in Pune';
import Corporatecabserviceinkaregaonmidc from './pages/Corporate Cab Services in Karegaon MIDC';
import Corporatecabserviceinshikrapur from './pages/Corporate Cab Services in Shikrapur MIDC';
import Bestcabserviceforcorporateemployeepune from './pages/Best Cab Service for Corporate Employees Pune';
import Corporatetravelcopaniesinpune from './pages/Corporate Travel Companies in Pune';
import Topcarrentalcompanyinpune from './pages/Top Car Rental Company in Pune';
import Corporatecarrentalserviceprovderinpune from './pages/Corporate Car Rental Service Provider in Pune';
import Luxurycarrentalinpune from './pages/Luxury Car Rentals in Pune';
import Ertigahireforcorporateinpune from './pages/Ertiga Hire for Corporate in Pune';
import Kiacarensonrentforcorporateinpune from './pages/Kia Carens On Rent for Corporate in Pune';
import Swiftdzireonrentinpuneforcorporate from './pages/Swift Dzire on Rent in Pune for Corporate';
import Corporatecabserviceinmumbai from './pages/Corporate Cab Services in Mumbai';
import Corporatecabserviceinbandrakurla from './pages/Corporate Cab Services in Bandra Kurla Complex';
import Corporatecabserviceinpowaimidc from './pages/Corporate Cab Services in Powai MIDC Mumbai';
import Mumbaiairportcorporatecabservice from './pages/Mumbai Airport Corporate Cab Services';
import Corporratecabdserviceinpalghar from './pages/Corporate Cab Service in Palghar MIDC';
import Corporatecabserviceforcorporateevents from './pages/Corporate Cab Services for Corporate Events in Mumbai';
import Corporatecabserviceinnavimumbai from './pages/Corporate Cab Services in Navi Mumbai Airport';
import Corporatecabserviceindelhi from './pages/Corporate Cab Services in Delhi';
import Corporatecabserviceingurgaon from './pages/Corporate Cab Service in Gurgaon';
import Corporatecabserviceindelhincr from './pages/Corporate Cab Services in Delhi NCR';
import Corporatecabserviceinokhladelhi from './pages/Corporate Cab Services in Okhla Delhi';
import Corporatecabserviceindelhiforindutrial from './pages/Corporate Cab Services in Delhi for Industrial';
import Corporatecabserviceinbanglore from './pages/Corporate Cab Services in Bangalore';
import Corporatecabstaxibanglore from './pages/Corporate Cabs Taxi Bangalore';
import Cabserviceinelectroniccity from './pages/Cab Service in Electronic City Bangalore';
import Corporatecabserviceinmanyatatech from './pages/Corporate Cab Services in Manyata Tech Park Nagavara Bangalore';
import Corporatecabserviceinbangloreinbagmanetech from './pages/Corporate Cab Services in Bagmane Tech Park CV Raman Nagar';
import Corporatecabserviceinouterringroad from './pages/Corporate Cab Services in Outer Ring Road ORR Corridor';
import Bangloreinternationalairport from './pages/Bangalore International Airport Corporate Cab Service';
import Outstationcorporatecabserviceinbanglore from './pages/Outstation Corporate Cab Service in Bangalore';
import Corporatecabserviceinchennai from './pages/Corporate Cab Services in Chennai';
import Corporatecabserviceinmadras from './pages/Corporate Cab Services in Madras';
import Corporatecabserviceinambatturchennai from './pages/Corporate Cab Service in Ambattur Chennai';
import Corporatecabserviceintidelpark from './pages/Corporate Cab Service in Tidel Park Chennai';
import Corporatecabserviceininternaatinaltech from './pages/Corporate Cab Service in International Tech Park Chennai ITPC';
import Corporatecabserviceinolympiatechpark from './pages/Corporate Cab Service in Olympia Tech Park Chennai';
import Corporatecabserviceinramanujan from './pages/Corporate Cab Service in Ramanujan IT City';
import Corporatecabserviceinpunee from './pages/Corporate Cab Service in Pune';


function App() {
  return (
   
    <Router >
      <ScrollToTop/>
      <ContactButtons/>
      {/* <ScrollToTop/>
     <Header />
  <ContactButtons/> */}
  <Header/>
      <Routes>
        
        <Route path="/" element={<Home/>} />
        <Route path="/about" element={<Aboutsectionn/>} />
        <Route path="/enquiry" element={<EnquiryForm/>} />
        <Route path="/testimonials" element={<Testimonialabout/>} />
        <Route path="/term-condition" element={<TermsConditions/>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/Faqs" element={<FaqsSection/>} />
        <Route path="/our-fleet" element={<Ourfleet/>} />
        <Route path="/Packages" element={<Packages/>} />
        <Route path="/Services" element={<OurServices/>} />
        <Route path="/Network" element={<OurNetwork/>} />
        <Route path="/Apartment" element={<ApartmentSection/>} />
        <Route path="/Booking" element={<Booking/>} />
        <Route path="/volvo-bus" element={<VolvoBusRental/>} />
        <Route path="/audi" element={<AudiLuxuryCars/>} />
        <Route path="/corporate-bus" element={<CorporateBus35Seater/>} />
        <Route path="/50-seater-bus" element={<FiftySeaterBus/>} />
        <Route path="/bmw" element={<BmwLuxuryCars/>} />
        <Route path="/sedan-cars" element={<SedanCars/>} />
        <Route path="/innova-crysta" element={<InnovaCrysta/>} />
        <Route path="/mini-bus" element={<MiniBus/>} />
        <Route path="/tempo-traveller" element={<TempoTraveller/>} />
        <Route path="/swift-desire" element={<Swift/>} />
        <Route path="/contact-us" element={<ContactSection/>} />
   
<Route path="/Corporate-Bus-Services-Pune" element={<Copporatebusserviceinpune />} />
<Route path="/Corporate-Cab-and-Bus-Service-in-Ahmednagar" element={<Coproratecabandbusserviceinahemadnagar />} />
<Route path="/Corporate-Cab-and-Bus-Service-in-Amravati" element={<Coproratecabandbusserviceinamravati />} />
<Route path="/Corporate-Cab-and-Bus-Service-in-Kolhapur" element={<Coproratecabandbusserviceinkohlapur />} />
<Route path="/Corporate-Cab-and-Bus-Service-in-Sangli" element={<Coproratecabandbusserviceisangli />} />
<Route path="/Corporate-Cab-and-Bus-Service-in-Satara" element={<Coproratecabandbusserviceisatara />} />
<Route path="/Corporate-Cab-and-Bus-Services-for-Outstation" element={<Corporateoutstation />} />
<Route path="/Corporate-Cab-and-Bus-Services-in-Aundh" element={<Corporatecabandbusaundh />} />
<Route path="/Corporate-Cab-and-Bus-Services-in-Aurangabad" element={<Corporatecabandbusserviceinauranga />} />
<Route path="/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC" element={<Corporatecabandbusserviceinbhosari />} />
<Route path="/Corporate-Cab-and-Bus-Services-in-Hadapsar" element={<Corporatecabandbusserviceinhadapsar />} />
<Route path="/Corporate-Cab-and-Bus-Services-in-Hinjewadi" element={<Corporatecabandbusserviceinhinjewadi />} />


<Route path="/Cab-Services-For-Corporate-Travellers-in-Mumbai" element={<Corporatecabandbusserviceinhinmumbai />} />
<Route path="/Corporate-Cab-and-Bus-Services-in-Nashik" element={<Corporatecabandbusserviceinhinnashik />} />
<Route path="/Corporate-Cab-and-Bus-Services-in-Pune" element={<Corporatecabandbusserviceinpune />} />
<Route path="/Corporate-Cab-and-Bus-Services-in-Sanaswadi" element={<Corporatecabandbusserviceinsanaswadi />} />
<Route path="/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC" element={<Corporatecabandbusserviceinshirwal />} />
<Route path="/Corporate-Cab-and-Bus-Services-in-Solapur" element={<Corporatecabinsolapur />} />
<Route path="/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC" element={<Corporatecabintalawade />} />
<Route path="/Corporate-Cab-and-Bus-Services-Pune-Airport" element={<Corporatecabandbusservicepuneairport />} />
<Route path="/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC" element={<Corporatecabandbusservicepuneranjangaon />} />
<Route path="/Corporate-Cabs-and-Bus-Services-in-Chakan" element={<Corporatecabandbusservicepunechakan />} />
<Route path="/Corporate-Cabs-and-Bus-Services-in-Nagpur" element={<Corporatecabandbusservicepunenagpur />} />
<Route path="/One-Way-Cab-Services-Mumbai-to-Pune-Drop" element={<Onewaycabservicemumbaitopunedrop />} />


<Route path="/Bus-Service-for-Corporate-Pune" element={<Busserviceforcorporatepune />} />
<Route path="/Bus-On-Rent-in-Pune-for-Corporate-Events" element={<Busonrentinpuneforcorporate />} />
<Route path="/Urbania-On-Rent-in-Pune-for-Corporate" element={<Urbaniaonrentinpuneforcorporate />} />
<Route path="/Corporate-Transport-Services-in-Pune" element={<Corporatetransportserviceinpune />} />
<Route path="/Luxury-Bus-Hire-for-Corporate-in-Pune" element={<Luxurybushireforcorporateinpune />} />
<Route path="/AC-Bus-Rental-for-Corporate-Pune" element={<Acbusrentalforcorporatepune />} />
<Route path="/Bus-Rental-for-Corporate-Outings-Pune" element={<Busrentalforcorporateoutingpune />} />
<Route path="/Volvo-Bus-on-Rent-for-Corporate-in-Pune" element={<Volvobusonrentforcorporate />} />
<Route path="/Corporate-Tour-Bus-Services-in-Pune" element={<Corporatetourbusserviceinpune />} />
<Route path="/Tempo-Traveller-on-Rent-for-Corporate-Pune" element={<Tempotravelleronrentforcorporate />} />




<Route path="/Innova-Crysta-Hire-for-Corporate-Events" element={<Innovacrystahireforcorporateevents />} />
<Route path="/Urbania-Hire-for-Corporate-Event-in-Pune" element={<Urbaniahireforcorporate />} />
<Route path="/Bus-Rental-For-Corporate-Events-in-Pune" element={<Busrentalforcorporateevents />} />
<Route path="/Corporate-Cab-service-in-Pune-Airport" element={<Corporatecabserviceinpune />} />
<Route path="/Mini-Bus-Hire-for-Corporate-in-Pune" element={<Minibushireforcorporate />} />
<Route path="/Luxury-Cab-Service-in-Pune-for-Corporate" element={<Luxurycabserviceinpuneforcorporate />} />
<Route path="/Monthly-Car-Rental-Cab-Service-in-Pune" element={<Monthlycarrentalcabserviceinpune />} />
<Route path="/Monthly-Cab-Service-in-Mumbai" element={<Monthlycabserviceinmumbai />} />
<Route path="/Monthly-Cab-Service-in-Navi-Mumbai" element={<Monthlycabserviceinnavymumbai />} />
<Route path="/Monthly-Cab-Service-in-Thane" element={<Monthlycabserviceinthane />} />
<Route path="/Monthly-Cab-Service-in-Pimpri-Chinchwad" element={<Monthlycabserviceinpimprichichwad />} />
<Route path="/Corporate-Cab-Service-in-Panvel" element={<Corporatecabserviceinpanvel />} />
<Route path="/Cabs-for-Corporate-Picnic-in-Pune" element={<Cabsforcorporatepicnic />} />
<Route path="/Bus-hire-for-Corporate-Picnic-in-pune" element={<Bushireforcorporatepicnicinpune />} />
<Route path="/Cab-Service-in-Wagahle-Industrial-Estate" element={<Cabserviceinwagaleindstrial />} />
<Route path="/Cab-Service-in-Taloja-Midc-Mumbai" element={<Cabserviceintaloja />} />
<Route path="/Corporate-Cab-Services-in-Thane-Industrial-Area-Midc" element={<Corporatecabserviceinthane />} />
<Route path="/Cab-Service-in-Hinjewadi-MIDC" element={<Cabserviceinhinjewadi />} />
<Route path="/Cab-Service-in-Chinchwad-MIDC-Pune" element={<Cabserviceinchichwad />} />
<Route path="/Cab-Service-Mahape-MIDC" element={<Cabservicemahapemidc />} />
<Route path="/Cab-Service-in-Marol-Midc-Andheri" element={<Cabserviceinmarol />} />
<Route path="/Cab-Service-in-Pimpri-MIDC" element={<Cabserviceinpimpri />} />
<Route path="/Cab-Service-in-Kurkumbh-Midc" element={<Cabserviceinkurkumbh />} />
<Route path="/Cab-Service-in-Supa-Midc" element={<Cabserviceinsupa />} />



<Route path="/Cab-Service-in-Talwade-Midc-Pune" element={<Cabserviceintalawade />} />
<Route path="/Cab-Services-in-Jejuri-Midc-Pune" element={<Cabserviceinjejuri />} />
<Route path="/Cab-Service-in-Pabal-Midc-Pune" element={<Cabserviceinpabal />} />
<Route path="/Cab-Service-in-Chakan-MIDC" element={<Cabserviceinchakan />} />
<Route path="/Cab-Service-in-Talegaon-Dabhade-Midc" element={<Cabserviceintalegaon />} />

<Route path="/Cab-Service-in-Andheri-Midc" element={<Cabserviceinandheri />} />
<Route path="/Cab-Service-in-Aurangabad-MIDC" element={<Cabserviceinaurangabad />} />
<Route path="/Cab-Service-in-Nagpur-MIDC" element={<Cabserviceinnagpur />} />
<Route path="/Cab-Service-in-Nanded-MIDC" element={<Cabserviceinnanded />} />
<Route path="/Cab-Service-in-Ratnagiri-MIDC" element={<Cabserviceinratnagiri />} />

<Route path="/Cab-Service-in-Sindhudurg-MIDC" element={<CAbserviceinsindhudurg />} />
<Route path="/Cab-Service-in-Raigad-MIDC" element={<Cabserviceinraigad />} />
<Route path="/Cab-Service-in-Kharadi-MIDC" element={<Csbserviceinkharadi />} />
<Route path="/Cab-Service-in-Wagle-Estate-Thane" element={<Cabserviceinwagleestatethane />} />
<Route path="/Cab-Service-in-Kolhapur-MIDC" element={<Cabserviceinkolhapur />} />

<Route path="/Cab-Service-in-Sangli-MIDC" element={<Cabserviceinsangli />} />
<Route path="/Cab-Service-in-Solapur-MIDC" element={<Cabserviceinsolapur />} />
<Route path="/Cab-Service-in-Satara-MIDC" element={<Cabserviceinsatara />} />
<Route path="/Cab-Service-in-Latur-MIDC" element={<Cabserviceinlatur />} />
<Route path="/Cab-Service-in-Dharashiv-Midc" element={<Cabserviceinsharashiv />} />
<Route path="/Corporate-Cab-Services-in-Jalgaon-Midc" element={<Corporatecabserviceinjalgaon />} />
<Route path="/Corporate-Cab-Service-in-Jalna-Midc-Maharashtra" element={<Corporatecabserviceinjalna />} />
<Route path="/Taxi-Service-in-Beed-Midc-Maharashtra" element={<Taxiserviceinbeed />} />
<Route path="/Cab-Service-in-Parbhani-MIDC" element={<Cabserviceinparbani />} />
<Route path="/Cab-Service-in-Hingoli-MIDC" element={<Cabserviceinhingoli />} />
<Route path="/Cab-Service-in-Dhule-MIDC" element={<Cabserviceindhule />} />
<Route path="/Car-Rental-Service-in-Wardha-Midc" element={<Carserviceinwardha />} />
<Route path="/Cab-Service-in-Chandrapur-Midc" element={<Cabserviceinchandrapur />} />
<Route path="/Cab-Service-in-Amravati-Midc-Maharashtra" element={<Cabserviceinamravati />} />
<Route path="/Cab-Service-in-Akola-MIDC" element={<Cabserviceinakola />} />
<Route path="/Cab-Service-in-Yavatmal-Midc" element={<Cabserviceinyavatmal />} />
<Route path="/Cab-service-in-buldhana-MIDC" element={<Cabserviceinbuldhana />} />
<Route path="/Corporate-Cab-Service-in-Igatpuri" element={<Corporatecabserviceinlgatpuri />} />
<Route path="/Corporate-Cab-Services-in-Nashik" element={<Corporatecabserviceinnashik />} />
<Route path="/Monthly-Car-Rental-Cab-Service-in-Nashik" element={<Monthlycarrentalcabserviceinnashik />} />




<Route path="/Cab-and-Bus-Services-in-Hadpsar-Industrial-Area" element={<Corporatecabandbusserviceinhadapsarindustrial />} />
<Route path="/Cab-and-Bus-Services-in-Dhayri-Industrial-Area" element={<Corporatecabandbusservieindhayari />} />
<Route path="/Cab-and-Bus-Services-in-Shivaji-Nagar" element={<Corporatecabandbusserviceinshiajinagar />} />
<Route path="/Cab-and-Bus-Services-in-Magarpatta" element={<Coporatecabandbusserviceinmagarpatta />} />
<Route path="/Cab-and-Bus-Services-in-Pirangut" element={<Corporatecabandbusserviceinpirangut />} />
<Route path="/Cab-and-Bus-Services-in-Nighoje-MIDC" element={<Corporatecabandbusserviceinnighole />} />
<Route path="/Cab-and-Bus-Services-in-Kharbwadi" element={<Corporatecabandbusserviceinkharbwadi />} />
<Route path="/Cab-and-Bus-Services-in-Khed-MIDC" element={<Corporatecabandbusserviceinkhed />} />
<Route path="/Cab-and-Bus-Services-in-Kargeaon-MIDC" element={<Corporatecabandbusserviceinkargaon />} />
<Route path="/Cab-and-Bus-Services-in-Nashik-Phata" element={<Corporatecabandbusserviceinnashikphata />} />
<Route path="/Cab-and-Bus-Services-in-Phugewadi" element={<Corporatecabandbusserviceinphugewadi />} />
<Route path="/Cab-and-Bus-Services-in-Phulgaon-MIDC" element={<Corporatecabandbusserviceinphulegaon />} />
<Route path="/Cab-and-Bus-Services-in-Markal-MIDC" element={<Corporatecabandbusserviceinmarkal />} />








<Route path="/employee-transport-services-in-pune" element={<Employeetransportserviceinpune />} />
<Route path="/cab-and-bus-services-in-baner" element={<Cabandbusserviceinbaner />} />
<Route path="/cab-and-bus-services-in-balewadi" element={<Cabandbusserviceinbalewadi />} />
<Route path="/corporate-car-rental-pune" element={<Corporatecarrentalpune />} />
<Route path="/corporate-staff-transport-pune" element={<Corporatestafftransportpune />} />
<Route path="/ac-bus-hire-for-employees-pune" element={<Acbushireforemployees />} />
<Route path="/car-rental-service-in-pune-for-corporates" element={<Carrentalserviceinpune />} />
<Route path="/best-employee-transportation-companies-in-pune" element={<Bestemployyestransportationcompnies />} />
<Route path="/affordable-employee-transportation-pune" element={<Affordableemployeestranportaion />} />
<Route path="/end-to-end-corporate-mobility-solutions" element={<Endtoendcorporate />} />
<Route path="/customized-mobility-plans-for-employees" element={<Customizedmobiltyplansforemploees />} />




<Route path="/Corporate-Car-Rental-in-Pune" element={<Corporatecarrentalinpune />} />
<Route path="/Corporate-Car-Rentals-Services-in-Pune" element={<Corporatecarrentalsserviceinpune />} />
<Route path="/Corporate-cab-services-for-Pune-Outstation" element={<Corporatecabserviceforpuneoutstation />} />
<Route path="/Corporate-Cab-Service-in-Viman-Nagar" element={<Corporatecabserviceinvimannagar />} />
<Route path="/Monthly-Pick-and-Drop-Service-Pune" element={<Monthlypickanddropservice />} />
<Route path="/Cab-Service-for-IT-Company-in-Pune" element={<Cabserviceforitcompanyinpune />} />
<Route path="/Daily-Office-Pickup-and-Drop-Service-in-Pune" element={<Dailyofficepickupanddropservice />} />
<Route path="/Corporate-Cab-Services-in-Karegaon-MIDC" element={<Corporatecabserviceinkaregaonmidc />} />
<Route path="/Corporate-Cab-Services-in-Shikrapur-MIDC" element={<Corporatecabserviceinshikrapur />} />
<Route path="/Best-Cab-Service-for-Corporate-Employees-Pune" element={<Bestcabserviceforcorporateemployeepune />} />
<Route path="/Corporate-Travel-Companies-in-Pune" element={<Corporatetravelcopaniesinpune />} />
<Route path="/Top-Car-Rental-Company-in-Pune" element={<Topcarrentalcompanyinpune />} />
<Route path="/Corporate-Car-Rental-Service-Provider-in-Pune" element={<Corporatecarrentalserviceprovderinpune />} />
<Route path="/Luxury-Car-Rentals-in-Pune" element={<Luxurycarrentalinpune />} />
<Route path="/Ertiga-Hire-for-Corporate-in-Pune" element={<Ertigahireforcorporateinpune />} />
<Route path="/Kia-Carens-On-Rent-for-Corporate-in-Pune" element={<Kiacarensonrentforcorporateinpune />} />
<Route path="/Swift-Dzire-on-Rent-in-Pune-for-Corporate" element={<Swiftdzireonrentinpuneforcorporate />} />
<Route path="/Corporate-Cab-Services-in-Mumbai" element={<Corporatecabserviceinmumbai />} />
<Route path="/Corporate-Cab-Services-in-Bandra-Kurla-Complex" element={<Corporatecabserviceinbandrakurla />} />
<Route path="/Corporate-Cab-Services-in-Powai-MIDC-Mumbai" element={<Corporatecabserviceinpowaimidc />} />
<Route path="/Mumbai-Airport-Corporate-Cab-Services" element={<Mumbaiairportcorporatecabservice />} />
<Route path="/Corporate-Cab-Service-in-Palghar-MIDC" element={<Corporratecabdserviceinpalghar />} />
<Route path="/Corporate-Cab-Services-for-Corporate-Events-in-Mumbai" element={<Corporatecabserviceforcorporateevents />} />
<Route path="/Corporate-Cab-Services-in-Navi-Mumbai-Airport" element={<Corporatecabserviceinnavimumbai />} />
<Route path="/Corporate-Cab-Services-in-Delhi" element={<Corporatecabserviceindelhi />} />
<Route path="/Corporate-Cab-Service-in-Gurgaon" element={<Corporatecabserviceingurgaon />} />
<Route path="/Corporate-Cab-Services-in-Delhi-NCR" element={<Corporatecabserviceindelhincr />} />
<Route path="/Corporate-Cab-Services-in-Okhla-Delhi" element={<Corporatecabserviceinokhladelhi />} />
<Route path="/Corporate-Cab-Services-in-Delhi-for-Industrial" element={<Corporatecabserviceindelhiforindutrial />} />
<Route path="/Corporate-Cab-Services-in-Bangalore" element={<Corporatecabserviceinbanglore />} />
<Route path="/Corporate-Cabs-Taxi-Bangalore" element={<Corporatecabstaxibanglore />} />
<Route path="/Cab-Service-in-Electronic-City-Bangalore" element={<Cabserviceinelectroniccity />} />
<Route path="/Corporate-Cab-Services-in-Manyata-Tech-Park-Nagavara-Bangalore" element={<Corporatecabserviceinmanyatatech />} />
<Route path="/Corporate-Cab-Services-in-Bagmane-Tech-Park-CV-Raman-Nagar" element={<Corporatecabserviceinbangloreinbagmanetech />} />
<Route path="/Corporate-Cab-Services-in-Outer-Ring-Road-ORR-Corridor" element={<Corporatecabserviceinouterringroad />} />
<Route path="/Bangalore-International-Airport-Corporate-Cab-Service" element={<Bangloreinternationalairport />} />
<Route path="/Outstation-Corporate-Cab-Service-in-Bangalore" element={<Outstationcorporatecabserviceinbanglore />} />
<Route path="/Corporate-Cab-Services-in-Chennai" element={<Corporatecabserviceinchennai />} />
<Route path="/Corporate-Cab-Services-in-Madras" element={<Corporatecabserviceinmadras />} />
<Route path="/Corporate-Cab-Service-in-Ambattur-Chennai" element={<Corporatecabserviceinambatturchennai />} />
<Route path="/Corporate-Cab-Service-in-Tidel-Park-Chennai" element={<Corporatecabserviceintidelpark />} />
<Route path="/Corporate-Cab-Service-in-International-Tech-Park-Chennai-ITPC" element={<Corporatecabserviceininternaatinaltech />} />
<Route path="/Corporate-Cab-Service-in-Olympia-Tech-Park-Chennai" element={<Corporatecabserviceinolympiatechpark />} />
<Route path="/Corporate-Cab-Service-in-Ramanujan-IT-City" element={<Corporatecabserviceinramanujan />} />
<Route path="/Corporate-Cab-Service-in-Pune" element={<Corporatecabserviceinpunee />} />

      </Routes>
     <Footer/>
    </Router>
  );
}

export default App;
